import { Button, Drawer, Icon } from '@economic/taco';
import { Trans } from '@lingui/macro';
import React from 'react';
import { HelpDrawerView } from '~/app/components/Header/Help/HelpDrawerView';

export interface EcopediaFrameViewProps {
    title: string | React.JSX.Element;
    link: string;
}

export function EcopediaFrameView({ title, link }: EcopediaFrameViewProps): React.JSX.Element {
    const embedLink = new URL(link);
    embedLink.searchParams.set('mode', 'helpdrawer');

    return (
        <HelpDrawerView title={title}>
            <div className="grow flex">
                <iframe title="E-copedia embedded" src={embedLink.href} className="flex-1" />
            </div>
            <Drawer.Footer>
                <Button href={link} appearance="primary" target="_blank">
                    <Icon name="undock" />
                    <Trans>View in e-copedia</Trans>
                </Button>
            </Drawer.Footer>
        </HelpDrawerView>
    );
}
